import { useMemo } from 'react';

import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';

import { IBaseItem } from '@rbi-ctg/menu';
import { ItemAvailabilityStatus } from 'enums/menu';
import { useFeatureMenu } from 'hooks/use-feature-menu';
import { useMenuContext } from 'state/menu';
import { useServiceModeContext } from 'state/service-mode';
import { ServiceMode } from 'state/service-mode/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

const useUpsellType = () => {
  const { serviceMode } = useServiceModeContext();
  return serviceMode === ServiceMode.DELIVERY
    ? 'upsellItemsAtCheckoutDelivery'
    : 'upsellItemsAtCheckoutRestaurant';
};

export function useCartUpsellItems() {
  const { cartEntries } = useMinimalCart();
  const { featureMenu, featureMenuLoading } = useFeatureMenu();
  const { getOneMenuItemAvailability } = useMenuContext();
  const { indexedMenu, isLoading: isMenuLoading } = useUnifiedMenuContext();
  const upsellType = useUpsellType();

  const items = useMemo(
    () =>
      (featureMenu?.[upsellType] || [])
        .filter((item: IBaseItem) => {
          if (!indexedMenu.isLoaded()) {
            return false;
          }
          const existsInCartEntries = cartEntries.find(cartEntry => cartEntry.id === item._id);
          const availability = getOneMenuItemAvailability(item._id);
          const isAvailable = availability.availabilityStatus === ItemAvailabilityStatus.AVAILABLE;
          return !existsInCartEntries && isAvailable;
        })
        .map(item => indexedMenu.find(item._id))
        .slice(0, 5),
    [cartEntries, featureMenu, getOneMenuItemAvailability, indexedMenu, upsellType]
  );

  const isLoading = featureMenuLoading || isMenuLoading || !indexedMenu.isLoaded();

  return {
    items,
    loading: isLoading,
  };
}
